import {
  cpIcon,
  dashboardIcon,
  labelServiceIcon,
  labelsIcon,
  PaymentIcon,
  referenceIcon,
  reportIcon,
  serviceReportIcon,
  userIcon,a
} from '../assets/images/img';

/** https://cp-rrp.rockvillegroup.com */

// export const APP_DOMAIN_PREFIX = `http://192.168.251.45:5500`;
// export const APP_DOMAIN_PREFIX = `http://localhost:5500`;  /** For local */
export const APP_DOMAIN_PREFIX = `https://cpreports-api.rockvillegroup.com`; /** For Production */
// export const APP_DOMAIN_PREFIX = `https://cpreports-api-stg.rockvillegroup.com`; /** For Staging */
export const API_URL = `${APP_DOMAIN_PREFIX}/api/v1`;
export const FILE_BASE_URL = 'http=//localhost=9000/';
// export const S3_BASE_URL = 'https://cprrp.s3.us-east-1.amazonaws.com'; //for staging
export const S3_BASE_URL = 'https://cprrpd.s3.us-east-1.amazonaws.com'; //for production


export const LABELS = {
  GO_BACK: '← Back',
  LOGOUT: '↶ Logout',
  LOGIN: 'Login',
  SIGNUP: 'Sign Up',
  REGISTER: 'Create User',
  EMAIL: 'Email Address',
  NAME: 'Username',
  FULL_NAME: 'Full Name',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  INVALID_MOBILE: 'Invalid mobile number'
};
export const PASSWORD = {
  passwordLength: 6,
  passwordLengthError: 'password is to short'
}
export const REGISTER = {
  SUCCESS_HEADER: "Success",
  SUCCESS_MESSAGE: "User Created Successfully!",
  FAILURE_HEADER: "Failure",
  FAILURE_MESSAGE: "Cannot Create User! User may already have been created with the given email!"
};
export const REGEXP_EMAIL = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2;3})+$/;
export const C_OTC_STORAGE = 'c_d_storage';
export const rbtArray = [7, 8, 9, 10]

export const sidebarTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  { text: 'user management', key: 'users', icon: userIcon },
  { text: 'consultant management', key: 'references', icon: referenceIcon },
  { text: 'CP management', key: 'cps', icon: cpIcon },
  // {text: 'parent label', key: 'parent-label', icon: parentLabelIcon},
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'content', key: 'contents', icon: dashboardIcon },
  { text: 'labels services', key: 'labels-service', icon: labelServiceIcon },
  { text: 'Upload reports', key: 'upload-reports', icon: reportIcon },
  { text: 'service report', key: 'service-report', icon: serviceReportIcon },
  { text: 'label revenue report', key: 'label-service-report', icon: labelsIcon },
  { text: 'content usage report', key: 'content-report', icon: reportIcon },
  { text: 'invoice-generation', key: 'invoice-generation', icon: PaymentIcon },
  { text: 'invoice report', key: 'invoice', icon: referenceIcon },
];

export const serviceCategory = [
  { key: 0, label: 'Pakistani Services', value: 0 },
  { key: 1, label: ' International Services', value: 1 },
  // ...role == '3' ? '' :[{ key: 1, label: ' International Services', icon: AirplayIcon, value: 1 }],
]

export const cpManagerTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  { text: 'consultant management', key: 'references', icon: referenceIcon },
  { text: 'CP management', key: 'cps', icon: cpIcon },
  // {text: 'parent label', key: 'parent-label', icon: parentLabelIcon},
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'content', key: 'contents', icon: dashboardIcon },
  { text: 'labels services', key: 'labels-service', icon: labelServiceIcon },
  { text: 'content usage report', key: 'content-report', icon: reportIcon },
];
export const cpTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  // {text: 'reference management', key: 'references', icon: referenceIcon},
  // {text: 'cp management', key: 'cps', icon: cpIcon},
  // {text: 'parent label', key: 'parent-label', icon: parentLabelIcon},
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'content', key: 'contents', icon: dashboardIcon },
  // {text: 'labels services', key: 'labels-service', icon: labelServiceIcon},
  { text: 'content usage report', key: 'content-report', icon: reportIcon },
  { text: 'label revenue report', key: 'label-service-report', icon: labelsIcon },
  { text: 'invoice report', key: 'invoice', icon: referenceIcon },


];
export const mediaTeamTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  // { text: 'reference management', key: 'references', icon: referenceIcon },
  // {text: 'parent label', key: 'parent-label', icon: parentLabelIcon},
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'content', key: 'contents', icon: dashboardIcon },
  { text: 'labels services', key: 'labels-service', icon: labelServiceIcon },
];
export const commercialTeamTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  { text: 'CP management', key: 'cps', icon: cpIcon },
  { text: 'reference management', key: 'references', icon: referenceIcon },
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'content', key: 'contents', icon: dashboardIcon },
  { text: 'labels services', key: 'labels-service', icon: labelServiceIcon },
  { text: 'Upload reports', key: 'upload-reports', icon: reportIcon },
  { text: 'service report', key: 'service-report', icon: serviceReportIcon },
  { text: 'content usage report', key: 'content-report', icon: reportIcon },
  { text: 'label revenue report', key: 'label-service-report', icon: labelsIcon },
  { text: 'invoice-generation', key: 'invoice-generation', icon: PaymentIcon },
  { text: 'invoice report', key: 'invoice', icon: referenceIcon },

];

export const financeTabsList = [
  { text: 'dashboard', key: 'dashboard', icon: dashboardIcon },
  { text: 'CP management', key: 'cps', icon: cpIcon },
  { text: 'labels', key: 'labels', icon: labelsIcon },
  { text: 'upload reports', key: 'upload-reports', icon: reportIcon },
  { text: 'service report', key: 'service-report', icon: serviceReportIcon },
  { text: 'label revenue report', key: 'label-service-report', icon: labelsIcon },
  { text: 'content usage report', key: 'content-report', icon: reportIcon },
  { text: 'invoice report', key: 'invoice', icon: referenceIcon },
];

export const jobStatus = [
  'pending', 'assigned', 'in route', 'delivered', 'completed',
];

export const userRoles = [
  { text: 'Admin', value: '1' },
  { text: 'CP Manager', value: '2' },
  { text: 'CP', value: '3' },
  { text: 'Finance', value: '4' },
  { text: 'Commercial Team', value: '5' },
  { text: 'Media Team', value: '6' }
]
export const userStatus = [
  { text: 'Active', value: '1' },
  { text: 'In-Active', value: '0' },
]
export const statusTypeOptions = [
  { text: 'Status', value: '' },
  { text: 'Active', value: '1' },
  { text: 'In-Active', value: '0' },
]
export const mediaType = [
  { text: 'Audio/Video', value: 'audio-video' },
  { text: 'FullTrack', value: 'FULLTRACK' },
  { text: 'Video', value: 'VIDEO' },
  { text: 'Movie', value: 'MOVIE' },
  { text: 'Podcast', value: 'PODCAST' },
  { text: 'Season', value: 'SEASON' },
]

export const musicGenre = [
  { text: 'Popular', value: 'popular' },
  { text: 'Comedy', value: 'comedy' },
  { text: 'Romantic', value: 'romantic' },
  { text: 'rock', value: 'rock' },
  { text: 'jazz', value: 'jazz' },
  { text: 'blues', value: 'blues' },
  { text: 'pop music', value: 'pop music' },
  { text: 'other', value: 'other' },
]
export const country = [
  { value: 'USA', text: 'United State' },
  { value: 'AF', text: 'Afghanistan' },
  { value: 'AL', text: 'Albania' },
  { value: 'DZ', text: 'Algeria' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AD', text: 'Andorra' },
  { value: 'AO', text: 'Angola' },
  { value: 'AI', text: 'Anguilla' },
  { value: 'AQ', text: 'Antarctica' },
  { value: 'AG', text: 'Antigua and/or Barbuda' },
  { value: 'AR', text: 'Argentina' },
  { value: 'AM', text: 'Armenia' },
  { value: 'AW', text: 'Aruba' },
  { value: 'AU', text: 'Australia' },
  { value: 'AT', text: 'Austria' },
  { value: 'AZ', text: 'Azerbaijan' },
  { value: 'BS', text: 'Bahamas' },
  { value: 'BH', text: 'Bahrain' },
  { value: 'BD', text: 'Bangladesh' },
  { value: 'BB', text: 'Barbados' },
  { value: 'BY', text: 'Belarus' },
  { value: 'BE', text: 'Belgium' },
  { value: 'BZ', text: 'Belize' },
  { value: 'BJ', text: 'Benin' },
  { value: 'BM', text: 'Bermuda' },
  { value: 'BT', text: 'Bhutan' },
  { value: 'BO', text: 'Bolivia' },
  { value: 'BA', text: 'Bosnia and Herzegovina' },
  { value: 'BW', text: 'Botswana' },
  { value: 'BV', text: 'Bouvet Island' },
  { value: 'BR', text: 'Brazil' },
  { value: 'IO', text: 'British lndian Ocean Territory' },
  { value: 'BN', text: 'Brunei Darussalam' },
  { value: 'BG', text: 'Bulgaria' },
  { value: 'BF', text: 'Burkina Faso' },
  { value: 'BI', text: 'Burundi' },
  { value: 'KH', text: 'Cambodia' },
  { value: 'CM', text: 'Cameroon' },
  { value: 'CV', text: 'Cape Verde' },
  { value: 'KY', text: 'Cayman Islands' },
  { value: 'CF', text: 'Central African Republic' },
  { value: 'TD', text: 'Chad' },
  { value: 'CL', text: 'Chile' },
  { value: 'CN', text: 'China' },
  { value: 'CX', text: 'Christmas Island' },
  { value: 'CC', text: 'Cocos Keeling} Islands' },
  { value: 'CO', text: 'Colombia' },
  { value: 'KM', text: 'Comoros' },
  { value: 'CG', text: 'Congo' },
  { value: 'CK', text: 'Cook Islands' },
  { value: 'CR', text: 'Costa Rica' },
  { value: 'HR', text: 'Croatia Hrvatska}' },
  { value: 'CU', text: 'Cuba' },
  { value: 'CY', text: 'Cyprus' },
  { value: 'CZ', text: 'Czech Republic' },
  { value: 'CD', text: 'Democratic Republic of Congo' },
  { value: 'DK', text: 'Denmark' },
  { value: 'DJ', text: 'Djibouti' },
  { value: 'DM', text: 'Dominica' },
  { value: 'DO', text: 'Dominican Republic' },
  { value: 'TP', text: 'East Timor' },
  { value: 'EC', text: 'Ecudaor' },
  { value: 'EG', text: 'Egypt' },
  { value: 'SV', text: 'El Salvador' },
  { value: 'GQ', text: 'Equatorial Guinea' },
  { value: 'ER', text: 'Eritrea' },
  { value: 'EE', text: 'Estonia' },
  { value: 'ET', text: 'Ethiopia' },
  { value: 'FK', text: 'Falkland Islands Malvinas}' },
  { value: 'FO', text: 'Faroe Islands' },
  { value: 'FJ', text: 'Fiji' },
  { value: 'FI', text: 'Finland' },
  { value: 'FR', text: 'France' },
  { value: 'FX', text: 'France, Metropolitan' },
  { value: 'GF', text: 'French Guiana' },
  { value: 'PF', text: 'French Polynesia' },
  { value: 'TF', text: 'French Southern Territories' },
  { value: 'GA', text: 'Gabon' },
  { value: 'GM', text: 'Gambia' },
  { value: 'GE', text: 'Georgia' },
  { value: 'DE', text: 'Germany' },
  { value: 'GH', text: 'Ghana' },
  { value: 'GI', text: 'Gibraltar' },
  { value: 'GR', text: 'Greece' },
  { value: 'GL', text: 'Greenland' },
  { value: 'GD', text: 'Grenada' },
  { value: 'GP', text: 'Guadeloupe' },
  { value: 'GU', text: 'Guam' },
  { value: 'GT', text: 'Guatemala' },
  { value: 'GN', text: 'Guinea' },
  { value: 'GW', text: 'Guinea-Bissau' },
  { value: 'GY', text: 'Guyana' },
  { value: 'HT', text: 'Haiti' },
  { value: 'HM', text: 'Heard and Mc Donald Islands' },
  { value: 'HN', text: 'Honduras' },
  { value: 'HK', text: 'Hong Kong' },
  { value: 'HU', text: 'Hungary' },
  { value: 'IS', text: 'Iceland' },
  { value: 'IN', text: 'India' },
  { value: 'ID', text: 'Indonesia' },
  { value: 'IR', text: 'Iran Islamic Republic of}' },
  { value: 'IQ', text: 'Iraq' },
  { value: 'IE', text: 'Ireland' },
  { value: 'IL', text: 'Israel' },
  { value: 'IT', text: 'Italy' },
  { value: 'CI', text: 'Ivory Coast' },
  { value: 'JM', text: 'Jamaica' },
  { value: 'JP', text: 'Japan' },
  { value: 'JO', text: 'Jordan' },
  { value: 'KZ', text: 'Kazakhstan' },
  { value: 'KE', text: 'Kenya' },
  { value: 'KI', text: 'Kiribati' },
  { value: 'KP', text: 'Korea, Democratic People\'s Republic of' },
  { value: 'KR', text: 'Korea, Republic of' },
  { value: 'KW', text: 'Kuwait' },
  { value: 'KG', text: 'Kyrgyzstan' },
  { value: 'LA', text: 'Lao People\'s Democratic Republic' },
  { value: 'LV', text: 'Latvia' },
  { value: 'LB', text: 'Lebanon' },
  { value: 'LS', text: 'Lesotho' },
  { value: 'LR', text: 'Liberia' },
  { value: 'LY', text: 'Libyan Arab Jamahiriya' },
  { value: 'LI', text: 'Liechtenstein' },
  { value: 'LT', text: 'Lithuania' },
  { value: 'LU', text: 'Luxembourg' },
  { value: 'MO', text: 'Macau' },
  { value: 'MK', text: 'Macedonia' },
  { value: 'MG', text: 'Madagascar' },
  { value: 'MW', text: 'Malawi' },
  { value: 'MY', text: 'Malaysia' },
  { value: 'MV', text: 'Maldives' },
  { value: 'ML', text: 'Mali' },
  { value: 'MT', text: 'Malta' },
  { value: 'MH', text: 'Marshall Islands' },
  { value: 'MQ', text: 'Martinique' },
  { value: 'MR', text: 'Mauritania' },
  { value: 'MU', text: 'Mauritius' },
  { value: 'TY', text: 'Mayotte' },
  { value: 'MX', text: 'Mexico' },
  { value: 'FM', text: 'Micronesia, Federated States of' },
  { value: 'MD', text: 'Moldova, Republic of' },
  { value: 'MC', text: 'Monaco' },
  { value: 'MN', text: 'Mongolia' },
  { value: 'MS', text: 'Montserrat' },
  { value: 'MA', text: 'Morocco' },
  { value: 'MZ', text: 'Mozambique' },
  { value: 'MM', text: 'Myanmar' },
  { value: 'NA', text: 'Namibia' },
  { value: 'NR', text: 'Nauru' },
  { value: 'NP', text: 'Nepal' },
  { value: 'NL', text: 'Netherlands' },
  { value: 'AN', text: 'Netherlands Antilles' },
  { value: 'NC', text: 'New Caledonia' },
  { value: 'NZ', text: 'New Zealand' },
  { value: 'NI', text: 'Nicaragua' },
  { value: 'NE', text: 'Niger' },
  { value: 'NG', text: 'Nigeria' },
  { value: 'NU', text: 'Niue' },
  { value: 'NF', text: 'Norfork Island' },
  { value: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NO', text: 'Norway' },
  { value: 'OM', text: 'Oman' },
  { value: 'PK', text: 'Pakistan' },
  { value: 'PW', text: 'Palau' },
  { value: 'PA', text: 'Panama' },
  { value: 'PG', text: 'Papua New Guinea' },
  { value: 'PY', text: 'Paraguay' },
  { value: 'PE', text: 'Peru' },
  { value: 'PH', text: 'Philippines' },
  { value: 'PN', text: 'Pitcairn' },
  { value: 'PL', text: 'Poland' },
  { value: 'PT', text: 'Portugal' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'QA', text: 'Qatar' },
  { value: 'SS', text: 'Republic of South Sudan' },
  { value: 'RE', text: 'Reunion' },
  { value: 'RO', text: 'Romania' },
  { value: 'RU', text: 'Russian Federation' },
  { value: 'RW', text: 'Rwanda' },
  { value: 'KN', text: 'Saint Kitts and Nevis' },
  { value: 'LC', text: 'Saint Lucia' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'Samoa' },
  { value: 'SM', text: 'San Marino' },
  { value: 'ST', text: 'Sao Tome and Principe' },
  { value: 'SA', text: 'Saudi Arabia' },
  { value: 'SN', text: 'Senegal' },
  { value: 'RS', text: 'Serbia' },
  { value: 'SC', text: 'Seychelles' },
  { value: 'SL', text: 'Sierra Leone' },
  { value: 'SG', text: 'Singapore' },
  { value: 'SK', text: 'Slovakia' },
  { value: 'SI', text: 'Slovenia' },
  { value: 'SB', text: 'Solomon Islands' },
  { value: 'SO', text: 'Somalia' },
  { value: 'ZA', text: 'South Africa' },
  { value: 'GS', text: 'South Georgia South Sandwich Islands' },
  { value: 'ES', text: 'Spain' },
  { value: 'LK', text: 'Sri Lanka' },
  { value: 'SH', text: 'St. Helena' },
  { value: 'PM', text: 'St. Pierre and Miquelon' },
  { value: 'SD', text: 'Sudan' },
  { value: 'SR', text: 'Suri' },
  { value: 'SJ', text: 'Svalbarn and Jan Mayen Islands' },
  { value: 'SZ', text: 'Swaziland' },
  { value: 'SE', text: 'Sweden' },
  { value: 'CH', text: 'Switzerland' },
  { value: 'SY', text: 'Syrian Arab Republic' },
  { value: 'TW', text: 'Taiwan' },
  { value: 'TJ', text: 'Tajikistan' },
  { value: 'TZ', text: 'Tanzania, United Republic of' },
  { value: 'TH', text: 'Thailand' },
  { value: 'TG', text: 'Togo' },
  { value: 'TK', text: 'Tokelau' },
  { value: 'TO', text: 'Tonga' },
  { value: 'TT', text: 'Trinidad and Tobago' },
  { value: 'TN', text: 'Tunisia' },
  { value: 'TR', text: 'Turkey' },
  { value: 'TM', text: 'Turkmenistan' },
  { value: 'TC', text: 'Turks and Caicos Islands' },
  { value: 'TV', text: 'Tuvalu' },
  { value: 'UG', text: 'Uganda' },
  { value: 'UA', text: 'Ukraine' },
  { value: 'AE', text: 'United Arab Emirates' },
  { value: 'GB', text: 'United Kingdom' },
  { value: 'UM', text: 'United States minor outlying islands' },
  { value: 'UY', text: 'Uruguay' },
  { value: 'UZ', text: 'Uzbekistan' },
  { value: 'VU', text: 'Vanuatu' },
  { value: 'VA', text: 'Vatican City State' },
  { value: 'VE', text: 'Venezuela' },
  { value: 'VN', text: 'Vietnam' },
  { value: 'VG', text: 'Virgin Islands British}' },
  { value: 'VI', text: 'Virgin Islands U.S.}' },
  { value: 'WF', text: 'Wallis and Futuna Islands' },
  { value: 'EH', text: 'Western Sahara' },
  { value: 'YE', text: 'Yemen' },
  { value: 'YU', text: 'Yugoslavia' },
  { value: 'ZR', text: 'Zaire' },
  { value: 'ZM', text: 'Zambia' },
  { value: 'ZW', text: 'Zimbabwe' },
]
export const musicMode = [
  { text: 'Ionian', value: 'Ionian' },
  { text: 'Dorian', value: 'Dorian' },
  { text: 'Phrygian', value: 'Phrygian' },
  { text: 'Lydian', value: 'Lydian' },
  { text: 'Lydian', value: 'Lydian' },
  { text: 'Mixolydian', value: 'Mixolydian' },
  { text: 'Aeolian', value: 'Aeolian' },
  { text: 'Aeolian', value: 'Aeolian' },
]

export const YesNoOption = [
  { text: 'Yes', value: '1' },
  { text: 'No', value: '0' },
]

export const ServicesArray = [
  { text: 'ZML', value: '1' },
  { text: 'ZMT', value: '2' },
  { text: 'Teleclips', value: '3' },
  { text: 'Vidly', value: '4' },
  { text: 'Jazzstream', value: '5' },
  { text: 'Bajao', value: '6' },
  { text: 'Jazz RBT', value: '7' },
  { text: 'Telenor RBT', value: '8' },
  { text: 'Ufone RBT', value: '9' },
  { text: 'Zong RBT', value: '10' },
  { text: 'Vidly International', value: '11' },
]

export const reportTypeOptions = [
  { text: 'Report Type', value: '' },
  // { text: 'Daily', value: 1 },
  // { text: 'Weekly', value: 7 },
  { text: 'Monthly', value: 30 },
  { text: 'Year', value: 365 },
]

export function getFormattedDate(date) {
  const date1 = new Date(date);                 // {object Date}
  const monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  let year = date1.getFullYear();
  let month = monthNames[date1.getMonth()];
  let day = date1.getDate().toString().padStart(2, '0');
  return year + '-' + month + '-' + day;
}

export const serviceTypeOptions = [
  { text: 'Service Wise', value: 1 },
  { text: 'Month Wise', value: 2 },
  // {text: 'Daily', value: 3},
]

export const regionOptions = [
  { text: 'Asia', value: 'asia' },
  { text: 'Africa', value: 'africa' },
  { text: 'North America', value: 'north america' },
  { text: 'South America', value: 'south america' },
  { text: 'Antarctica', value: 'antarctica' },
  { text: 'Europe', value: 'europe' },
  { text: 'Australia', value: 'australia' },
]

export const cpCategoryOptions = [
  { text: 'Pakistani', value: '10' },
  { text: 'Bollywood', value: '11' },
  { text: 'western', value: '12' },
]
export const contentCategoryOptions = [
  { text: 'Pakistani', value: '1' },
  { text: 'Bollywood', value: '2' },
  { text: 'western', value: '3' },
  { text: 'islamic', value: '78' },
]
export const contentGenreOptions = [
  { text: 'Pakistani', value: '1' },
  { text: 'Bollywood', value: '2' },
  { text: 'western', value: '3' },
  { text: 'islamic', value: '78' },
]
export const contentMoodOptions = [
  { text: 'Romance', value: '7' },
  { text: 'Sad', value: '8' },
  { text: 'Wedding Songs', value: '56' },
  { text: 'Happy', value: '10' },
  { text: 'Classic', value: '6' },
  { text: 'Party', value: '14' },
  { text: 'Dance', value: '15' },
  { text: 'Patriotic', value: '55' },
  { text: 'Islamic', value: '99' },
  { text: 'Remixes', value: '20' },
  { text: 'Remix', value: '20' },
  { text: 'Hip Hop', value: '22' },
  { text: 'Slow', value: '5' },
  { text: 'Oldies', value: '23' },
  { text: 'Sufi Music', value: '26' },
  { text: 'Tapay', value: '49' },
  { text: 'Ghazals', value: '71' },
  { text: 'Folk', value: '51' },
  { text: 'Pop', value: '13' },
  { text: 'Thriller', value: '24' },
  { text: 'Chill', value: '78' },
  { text: 'Driving', value: '100' },
  { text: 'Traveling', value: '102' },
  { text: 'Workout', value: '101' },
  { text: 'Romantic', value: '28' },
  { text: 'Wedding', value: '67' },
]

export const labelCategoryOptions = [
  { text: 'Arabic', value: '10' },
  { text: 'Balochi', value: '11' },
  { text: 'Bollywood', value: '12' },
  { text: 'English', value: '13' },
  { text: 'Hindko', value: '14' },
  { text: 'Islamic', value: '15' },
  { text: 'Pashto', value: '16' },
  { text: 'Punjabi', value: '17' },
  { text: 'Regional', value: '18' },
  { text: 'Saraiki', value: '19' },
  { text: 'Sindhi', value: '20' },
  { text: 'Urdu', value: '21' },
  // {text: 'ALL', value: '21'},
]
export const labelAcquisitionOptions = [
  { text: 'revenue share ', value: '1' },
  { text: 'fixed fee', value: '2' },
  { text: 'MG+Revenue share', value: '3' },
]

export const labelTypeOptions = [
  { text: 'MG', value: 'MG' },
  { text: 'Non-MG', value: 'Non-MG' },
  { text: 'N/A', value: 'N/A' },
  { text: 'All', value: 'all' },
  { text: 'Consultant', value: 'ref' },
]

export const acquisitionOptions = [
  { text: 'direct', value: '1' },
  { text: 'indirect', value: '2' },
]

export const designationOptions = [
  { text: 'CEO', value: 'ceo' },
  { text: 'director', value: 'director' },
  { text: 'manager', value: 'manager' },
  { text: 'artist', value: 'artist' },
  { text: 'owner', value: 'owner' },
  { text: 'fiance Member', value: 'fianceMember' },
  { text: 'managing partner', value: 'managingPartner' },
  { text: 'business POC', value: 'businessPOC' },
  { text: 'content manager', value: 'contentManager' },
  { text: 'POC 1', value: 'POC 1' },
  { text: 'Head of Strategy', value: 'Head of Strategy' },
  // {text: 'director', value: 'director'},
]
export const servicesTypes = [
  { text: 'All', value: 'All' },
  { text: 'ZML', value: 'ZML' },
  { text: 'ZMT', value: 'ZMT' },
  { text: 'Teleclips', value: 'Teleclips' },
  { text: 'Vidly', value: 'Vidly' },
  { text: 'Jazzstream', value: 'Jazzstream' },
  { text: 'Bajao', value: 'Bajao' },
  { text: 'Jazz RBT', value: 'Jazz RBT' },
  { text: 'Telenor RBT', value: 'Telenor RBT' },
  { text: 'Ufone RBT', value: 'Ufone RBT' },
  { text: 'Zong RBT', value: 'Zong RBT' },
  { text: 'Vidly International', value: 'Vidly International' },
  { text: 'Lebara KSA', value: 'Lebara KSA' },
  { text: 'Mobily KSA', value: 'Mobily KSA' },
  { text: 'Zain SDP', value: 'Zain SDP' },
  { text: 'Ooredoo Oman', value: 'Ooredoo Oman' },
  { text: 'Vodafone Qatar', value: 'Vodafone Qatar' },
  { text: 'DU UAE', value: 'DU UAE' },
  { text: 'Etisalat UAE', value: 'Etisalat UAE' },
  { text: 'Viva STC', value: 'Viva STC' },
  { text: 'Zain Bahrain', value: 'Zain Bahrain' },
  { text: 'Ooredoo Kuwait', value: 'Ooredoo Kuwait' },
  { text: 'Zain Kuwait', value: 'Zain Kuwait' },
  { text: 'Zain KSA', value: 'Zain KSA' },
]
export const chartTypes = [
  { text: 'Column Chart', value: 'ColumnChart' },
  { text: 'Bar Chart', value: 'BarChart' },
  { text: 'Line Chart', value: 'LineChart' },
]
export const dashboardReportYearOptions = [
  { text: '2021', value: '2021' },
  { text: '2022', value: '2022' },
  { text: '2023', value: '2023' },
  { text: '2024', value: '2024' },
  { text: '2025', value: '2025' },
  { text: '2026', value: '2026' },
]
export const invoiceStatusOptions = [
  { text: 'Budgeting For Payment', value: 1 },
  { text: 'Awaiting Budget Approval (Success) ', value: 2 },
  { text: 'Awaiting Budget Approval (Failure)', value: 3 },
  { text: 'Invoicing Email ', value: 4 },
  // {text: 'Invoicing Email  (Failure)', value: 5},
  { text: 'Pending Invoice Approval  (Success)', value: 5 },
  { text: 'Pending Invoice Approval  (Failure)', value: 6 },
  { text: 'Pending Clearance From Finance  (Success)', value: 7 },
  { text: 'Pending Clearance From Finance  (Failure)', value: 8 },
  { text: 'On Hold By Finance', value: 9 },
  { text: 'Invoice Cleared', value: 10 },
  { text: 'Invoice Rejected', value: 11 },
]
export const cpInvoiceStatusOptions = [
  { text: 'Invoicing Email ', value: 4 },
  { text: 'Pending Invoice Approval  (Success)', value: 5 },
  { text: 'Pending Invoice Approval  (Failure)', value: 6 },
  { text: 'Pending Clearance From Finance  (Success)', value: 7 },
  { text: 'Pending Clearance From Finance  (Failure)', value: 8 },
  { text: 'On Hold By Finance', value: 9 },
  { text: 'Invoice Cleared', value: 10 },
  { text: 'Invoice Rejected', value: 11 },
]
export const financeTeamInvoiceStatusOptions = [
  { text: 'Awaiting Budget Approval (Success) ', value: 2 },
  { text: 'Awaiting Budget Approval (Failure)', value: 3 },
  { text: 'Pending Clearance From Finance  (Success)', value: 7 },
  { text: 'Pending Clearance From Finance  (Failure)', value: 8 },
  { text: 'On Hold By Finance', value: 9 },
  { text: 'Invoice Cleared', value: 10 },
]
export const commercialTeamInvoiceStatusOptions = [
  { text: 'Budgeting For Payment', value: 1 },
  { text: 'Invoicing Email ', value: 4 },
  { text: 'Pending Invoice Approval  (Success)', value: 5 },
  { text: 'Pending Invoice Approval  (Failure)', value: 6 },
  { text: 'Invoice Rejected', value: 11 },
]
export const statusFailureCase = [3, 6, 8, 9, 11]
export const statusFailureCase1 = [5, 6, 7, 8, 9, 10, 11]
export const statusFailureDepositSlip = [10]

export const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const mobileNumberRegex = /^[\+]?[(]?[0-9]{2}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{5,}$/im


export const invoicesSmartHeadCells = [
  { id: "gross revenue", numeric: false, disablePadding: false, label: "CP ID" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "CP Name" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Share" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Revenue" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Gross Revenue" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "status" },
  { id: "start date", numeric: false, disablePadding: false, label: "start date", },
  { id: "end date", numeric: true, disablePadding: false, label: "end date" },
];
export let labelsListingHeadCells = [
  { id: "iddafdf", numeric: false, disablePadding: false, label: "" },
  { id: "iddafdf", numeric: false, disablePadding: false, label: "label ID" },
  { id: "iddafdf", numeric: false, disablePadding: false, label: "label name" },
  { id: "email", numeric: false, disablePadding: false, label: "label share (%)", },
  { id: "email", numeric: false, disablePadding: false, label: "label gross revenue", },
  { id: "email", numeric: false, disablePadding: false, label: "label revenue", },
  { id: "end_date", numeric: false, disablePadding: false, label: "contract end date", },
  { id: "cont_status", numeric: false, disablePadding: false, label: "contract status", },
];
export let labelsListingRefHeadCells = [
  { id: "iddafdf", numeric: false, disablePadding: false, label: "" },
  { id: "iddafdf", numeric: false, disablePadding: false, label: "label ID" },
  { id: "iddafdf", numeric: false, disablePadding: false, label: "label name" },
  { id: "email", numeric: false, disablePadding: false, label: "Consultant share (%)", },
  { id: "email", numeric: false, disablePadding: false, label: "label gross revenue", },
  { id: "email", numeric: false, disablePadding: false, label: "label  revenue", },
  { id: "end_date", numeric: false, disablePadding: false, label: "contract end date", },
  { id: "cont_status", numeric: false, disablePadding: false, label: "contract status", },
];
export const invoicesHeadCells = [
  { id: "gross revenue", numeric: false, disablePadding: false, label: "CP ID" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "CP Name" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Share" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Gross Revenue" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "Label Revenue" },
  { id: "gross revenue", numeric: false, disablePadding: false, label: "status" },
  { id: "start date", numeric: false, disablePadding: false, label: "start date", },
  { id: "end date", numeric: true, disablePadding: false, label: "end date" },
  { id: "file", numeric: true, disablePadding: false, label: "Upload Invoice" },
  { id: "upload", numeric: true, disablePadding: false, label: "deposit slip" },

];

export const genresOptions = [
  // {text: 'Genre_Title', value: '100'},
  { text: 'Folk', value: '64' },
  { text: 'Pop', value: '15' },
  { text: 'Romantic', value: '11' },
  { text: 'Rock', value: '16' },
  { text: 'Wedding Songs', value: '179' },
  { text: 'Dance', value: '20' },
  { text: 'Hip Hop', value: '22' },
  { text: 'Movie Songs', value: '211' },
  { text: 'Patriotic', value: '73' },
  { text: 'Coke Studio', value: '72' },
  { text: 'Romance', value: '78' },
  { text: 'Rap', value: '18' },
  { text: 'Remix', value: '180' },
  { text: 'Classic', value: '126' },
  // {text: 'Remixes', value: '78'},
  { text: 'Qawali', value: '127' },
  { text: 'Qawwali', value: '225' },
  { text: 'Item Song', value: '134' },
  { text: 'Punjabi', value: '135' },
  { text: 'Ghazals', value: '209' },
  { text: 'Ghazal', value: '177' },
  { text: 'Sufi Music', value: '178' },
  { text: 'Tapay', value: '181' },
  { text: 'Popular', value: '1' },
  { text: 'Sad', value: '136' },
  { text: 'Classics', value: '218' },
  { text: 'Instrumental', value: '138' },
  { text: 'Sindhi', value: '207' },
  { text: 'Action', value: '4' },
  { text: 'Urdu', value: '208' },
  { text: 'Islamic', value: '210' },
  { text: 'Hip-Hop/Rap', value: '32' },
  { text: 'Blues', value: '44' },
  { text: 'R&B', value: '27' },
  { text: 'Quran E Kareem', value: '254' },
  { text: 'Naat', value: '253' },
  { text: 'Hamd', value: '255' },
  { text: 'Manqabat', value: '256' },
  { text: 'Qaseeda', value: '259' },
  { text: 'Noha', value: '258' },
  { text: 'Podcasts', value: '260' },
  { text: 'Single', value: '246' },
  { text: 'Latin / Regional Mexican', value: '288' },
  { text: 'Electronic', value: '33' },
  { text: 'Christian', value: '289' },
  { text: 'Soundtrack', value: '71' },
  { text: 'Classical', value: '30' },
  { text: 'New Age', value: '66' },
  { text: 'TV/Film', value: '279' },
  { text: 'Holiday', value: '88' },
  { text: 'Classical Crossover', value: '52' },
  { text: 'Jazz', value: '24' },
  { text: 'Children', value: '80' },
  { text: 'J-POP', value: '287' },
  { text: 'Reggae', value: '36' },
  { text: 'Musique Francophone', value: '310' },
  { text: 'Country', value: '23' },
  { text: 'Latin', value: '21' },
  { text: 'MPB', value: '298' },
  { text: 'Schlager', value: '81' },
  { text: 'Forró', value: '321' },
  { text: 'World', value: '269' },
  { text: 'Alternative', value: '19' },
  { text: 'Vocal', value: '274' },
  { text: 'Kayokyoku', value: '313' },
  { text: 'Fitness & Workout', value: '318' },
  { text: 'Latin / Pop', value: '292' },
  { text: 'Tamil', value: '322' },
  { text: 'K-POP', value: '300' },
  { text: 'Bollywood', value: '239' },
  { text: 'Latin / Urban', value: '290' },
  { text: 'Anime', value: '323' },
  { text: 'Mandopop', value: '283' },
  { text: 'Afro-Beat', value: '324' },
  { text: 'Latin / Rock', value: '278' },
  { text: 'Indian Pop', value: '25' },
  { text: 'French Pop', value: '281' },
  { text: 'Afrobeats', value: '325' },
  { text: 'Sertanejo', value: '299' },
  { text: 'Pagode', value: '307' },
  { text: 'Spoken Word', value: '59`' },
  { text: 'Cantopop', value: '271' },
  { text: 'Funk', value: '296' },
  { text: 'Singer Songwriter', value: '261' },
  { text: 'Latin / Tropical', value: '297' },
  { text: 'Kids & Family (Film)', value: '315' },
  { text: 'Afrikaans', value: '184' },
  { text: 'Flamenco', value: '262' },
  { text: 'Gospel', value: '282' },
  { text: 'Samba', value: '293' },
  { text: 'Metal', value: '272' },
  { text: 'Musical', value: '122' },
  { text: 'Volksmusik', value: '276' },
  { text: 'Kids (TV)', value: '326' },
  { text: 'Easy Listening', value: '38' },
  { text: 'Disco', value: '280' },
  { text: 'Fado', value: '275' },
  { text: 'Comedy', value: '2' },
  { text: 'Punk', value: '57' },
  { text: 'Soul', value: '95' },
  { text: 'Axé', value: '320' },
  { text: 'Bossa nova', value: '286' },
  { text: 'Jovem Guarda', value: '327' },
  { text: 'Samba Rock', value: '328' },
  { text: 'Karaoke', value: '329' },
  { text: 'Adult Contemporary', value: '37' },
  { text: 'Reggaeton', value: '285' },
  { text: 'Indian Classical', value: '273' },
  { text: 'Afro-Pop', value: '330' },
  { text: 'Tango', value: '291' },
  { text: 'Brega', value: '331' },
  { text: 'African', value: '332' },
  { text: 'Afro Soul', value: '84' },
  { text: 'Kuduro', value: '333' },
  { text: 'Bluegrass', value: '284' },
  { text: 'Swing', value: '304' },
  { text: 'Caribbean', value: '314' },
  { text: 'Classic Rock', value: '61' },
  { text: 'Lambada Brasileiro', value: '334' },
  { text: 'Motown', value: '338' },
  { text: 'Maskandi', value: '345' },
  { text: 'Zouglou', value: '352' },
  { text: 'Ndombolo', value: '359' },
  { text: 'Highlife', value: '366' },
  { text: 'Afro House', value: '373' },
  { text: 'Bhangra', value: '380' },
  { text: 'Broadway (Mobile)', value: '387' },
  { text: 'Kizomba', value: '394' },
  { text: 'Regional Indian', value: '130' },
  { text: 'Choro', value: '401' },
  { text: 'Independent (Film)', value: '301' },
  { text: 'Coupé-Décalé', value: '408' },
  { text: 'Native American', value: '415' },
  { text: 'Oldies', value: '58' },
]
